import { render, staticRenderFns } from "./benchmarkChart.vue?vue&type=template&id=5c09c80a&"
import script from "./benchmarkChart.vue?vue&type=script&lang=js&"
export * from "./benchmarkChart.vue?vue&type=script&lang=js&"
import style0 from "./benchmarkChart.vue?vue&type=style&index=0&id=5c09c80a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports